import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SafetySection() {
  const { t } = useTranslation();

  return (
    <section id="safety" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-2xl border border-background-200 bg-background-100 p-8 md:p-12">
          <div className="flex flex-col items-start gap-6 md:flex-row md:items-center">
            <span className="w-14 h-14 flex shrink-0 items-center justify-center rounded-2xl bg-secondary-100 text-secondary-700">
              <i className="ri-shield-check-line text-2xl"></i>
            </span>
            <div className="flex-1">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {t("safety.title")}
              </h2>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-foreground-600">
                {t("safety.text")}
              </p>
            </div>
            <Link
              to="/guide/safety-guide"
              className="inline-flex shrink-0 items-center gap-2 rounded-full bg-secondary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
            >
              {t("safety.cta")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}